<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import ComplementaryHealthData from '@/data/company-page-data/groupama-sigorta/cross-pages/ComplementaryInsurance'
export default {
  metaInfo: {
    title: 'En Uygun Groupama Sigorta Tamamlayıcı Sağlık Sigortası Fiyatları',
    meta: [
      {
        name: 'description',
        content: 'Groupama tamamlayıcı sağlık sigortası teklifi isteyin, geniş anlaşmalı hastane ağlarından sağlık hizmeti alın, fark ücreti ödemeye son verin.'
      }
    ]
  },
  name: 'GroupamaSigortaComplementaryHealth',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: ComplementaryHealthData.headerContent,
      crossPageContent: ComplementaryHealthData.crossPageContent,
      faqTitle: ComplementaryHealthData.faqTitle,
      faqTitleDesc: ComplementaryHealthData.faqTitleDesc,
      getPrice: ComplementaryHealthData.getPrice
    }
  }
}
</script>
